import api from '@parent/api/index.js';
let query = app.tool.parseQuery();
let token = app.ls.get('x3-parent-token');

app.http.setHeader('x3-company', query.companyId || 'empty');
if (token) {
  app.http.setHeader('x3-authentication', token);
} else {
  // 因为家长端可以匿名访问，所以一定不能放开下面的代码
  // location.href = `${location.origin}/app/simple${location.search}#/parentLogin?redirect=${encodeURIComponent(location.href)}`;
}


// OSS上传相关配置
xgjzt.oss.setConfig({
  max: 2,
  env: process.env.VUE_APP_x3_env,
  getStsParams: api.getOssRequest,
  isEncrypt:true,
  fileNameType:2, // 1原文件名，2随机文件名
});


// 为了与后端调试方便
let name = app.tool.parseQuery().name;
if (name) {
  app.http.setHeader('x3-version', name);
}

app.http.setHeader('yunxiao-version', '3.51');

app.parent = {
  // face: 表示从脸到公众号进入该应用
  app_type: query.app_type,
  user: {
    thirdAppId: '',
    wxOpenId: '',
  },
  // 不同环境，登录
  login(url) {
    let redirectUrl = encodeURIComponent(url || location.href);
    if (app.base.env == 'wxxcx') {
      wx.miniProgram.navigateTo({
        url: `/src/pages/parent/login/login?switch=0&redirect=${redirectUrl}`,
      });
    } else {
      // location.href = `/app/simple${location.search}#/parentLogin?switch=0&wxOpenId=${this.user.wxOpenId}&thirdAppId=${this.user.thirdAppId}&redirect=${redirectUrl}`;
      let loginURl = `/app/simple${location.search}#/parentLogin?switch=0&wxOpenId=${this.user.wxOpenId}&thirdAppId=${this.user.thirdAppId}&redirect=${redirectUrl}`;
      location.replace(loginURl);
    }
  },
  //  临时增加跳转到脸到登录
  loginFace() {
    location.href = `/app/simple${location.search}#/faceLogin?wxOpenId=${app.parent.user.wxOpenId}&thirdAppId=${app.parent.user.thirdAppId}`;
  },
  // 退出登录，切换账户
  async switchUser(url) {
    await api.userLogout();
    app.ls.remove('x3-parent-token');

    let redirectUrl = encodeURIComponent(url || location.href.split('#')[0]);
    if (app.base.env == 'wxxcx') {
      wx.miniProgram.navigateTo({
        url: `/src/pages/parent/login/login?switch=1&redirect=${redirectUrl}`,
      });
    } else {
      location.href = `/app/simple${location.search}#/parentLogin?switch=1&wxOpenId=${this.user.wxOpenId}&thirdAppId=${this.user.thirdAppId}&redirect=${redirectUrl}`;
    }
  },
  // 完善用户信息 暂时没有用到
  // fillUserInfo () {
  //     console.log(">>>????");
  //     if (app.base.env == "wxxcx") {
  //         wx.miniProgram.navigateTo({
  //             url: `/src/pages/parent/auth-user/auth-user?redirect=${encodeURIComponent(location.href)}`,
  //         });
  //     } else {
  //         // 去完善信息
  //     }
  // },
  //
  //  不同环境，支付; allPay: 是否支付剩余所有金额
  async pay(id, allPay) {
    if (app.base.env == 'wxxcx') {
      let payResultPage = `${location.href.split('#')[0]}#/payResult?id=${id}`,
        redirectUrl = encodeURIComponent(payResultPage);
      wx.miniProgram.navigateTo({
        url: `/src/pages/parent/payment/payment?id=${id}&redirect=${redirectUrl}`,
      });
    } else {
      let ret = await api.orderInfoPayment({
        orderId: id,
        allPay: allPay,
      });
      if(ret.code == 820000005) { // 需判断机构当前收费校区是否已启用收款商户
        vant.Dialog.alert({
          message: `${ret.msg}暂不支持线上支付，请联系老师付款`,
          confirmButtonText: '我知道了',
        });
      }
      location.href = ret.data.paymentResult.qrCodePayUrl;
    }
  },
  authSubscribe() {
    console.log('去订阅推送消息 >>>>>>>>>> ');
    wx.miniProgram.navigateTo({
      url: `/src/pages/parent/auth-msg/auth-msg`,
    });
  },
};


